import { get, post } from '@/utils/request'

const agentApi = {
  /* 用户管理-下游代理商-重置密钥 */
  resetKey: function(id) {
    return post('/member/agent/reset-key/' + id)
  },
  /* 用户管理-下游代理商-重置密码 */
  resetPwd: function(id) {
    return post('/member/agent/reset-pwd/' + id)
  },
  /* 用户管理-下游代理商-添加或编辑（如果是编辑则需要传ID参数） */
  getInit: function(id) {
    return get('/member/agent/save-update-init', { id })
  },
  /* 用户管理-下游代理商-修改价格 */
  updatePrice: function(params) {
    return post('/member/agent/update-price', {
      id: params.id,
      salePrice: params.salePrice,
    })
  },
  /* 用户管理-下游代理商-添加或编辑（如果是编辑则需要传ID参数） */
  saveForm: function(params) {
    return post('/member/agent/save-update', {
      ...params,
    })
  },
  /* 用户管理_下游代理商-查看详情 */
  viewDetail: function(id) {
    return get('/member/agent/detail/' + id)
  },
  /* 获取所有的下游代理商 用户管理_下游代理商，查询所有 */
  getAll: function(memberType) {
    return get('/member/agent/list-all', { memberType })
  },
  //获取关联初始化
  getRateInit: function(id) {
    return get('/member/agent/product/init/' + id)
  },
  //单关联
  singleRate: function(data) {
    return post('/member/agent/product/bind', data)
  },
  //批量关联
  batchRate: function(data) {
    return post('/member/agent/product/batchBind', data)
  },
}

export default agentApi



// WEBPACK FOOTER //
// ./src/api/agent.js